// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HeartBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22.25 3.5c-2.511 0-4.74.991-6.25 2.695C14.49 4.491 12.261 3.5 9.75 3.5a8.26 8.26 0 0 0-8.25 8.25c0 9.043 13.226 16.267 13.789 16.571a1.5 1.5 0 0 0 1.422 0c.563-.304 13.789-7.529 13.789-16.571a8.26 8.26 0 0 0-8.25-8.25Zm-.686 17.795A41.085 41.085 0 0 1 16 25.27a41.092 41.092 0 0 1-5.564-3.975C7.728 18.971 4.5 15.427 4.5 11.75A5.25 5.25 0 0 1 9.75 6.5c2.225 0 4.088 1.175 4.861 3.068a1.501 1.501 0 0 0 2.778 0C18.163 7.675 20.025 6.5 22.25 6.5a5.25 5.25 0 0 1 5.25 5.25c0 3.678-3.227 7.221-5.936 9.545Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
